import React from "react";
import { LocalKeys, useTranslation } from "utilities/i18n";
import { SUPPORT_LINKS, SupportLinkType } from "Constants";
import PolyIcon from "../PolyIcon";

const translationKeys: Record<SupportLinkType, LocalKeys> = {
  [SupportLinkType.HOME]: "SUPPORT_HOME",
  [SupportLinkType.DOCS_AND_SOFTWARE]: "SUPPORT_DOCS_AND_SOFTWARE",
  [SupportLinkType.KNOWLEDGE_BASE]: "SUPPORT_KNOWLEDGE_BASE",
  [SupportLinkType.DEVICES]: "SUPPORT_DEVICES",
  [SupportLinkType.LENS]: "SUPPORT_LENS"
};

export const SupportLink: React.FC<{
  type?: SupportLinkType;
  location?: string;
  text?: LocalKeys;
  icon?: string;
}> = ({ type = SupportLinkType.HOME, location, text, icon }) => {
  const { t } = useTranslation();
  const baseLocation = SUPPORT_LINKS[type];
  const url = baseLocation + (location ? "/" + location : "");
  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      {icon && <PolyIcon className="mr-5 white" icon={icon} />}
      {text ? t(text) : t(translationKeys[type])}
    </a>
  );
};
